export default {
  // 搜索区
  drawTime: '开奖时间',
  startTime: '开始时间',
  endTime: '结束时间',
  member_keyword: '用户信息',
  member_keywordPlaceholder: '请输入用户名称、UID',
  code: '码号',
  codePlaceholder: '请输入二维码、防伪码或流水码',
  is_award: '中奖状态',
  is_awardPlaceholder: '请选择',
  is_awardWon: '中奖',
  is_awardNotWon: '未中奖',
  activity_keyword: '活动信息',
  activity_keywordPlaceholder: '请输入活动名称或ID',
  country_id: '扫码国家/地区',
  country_idPlaceholder: '请选择',
  search: '搜索',
  // 表格列
  colUserInfo: '用户信息',
  colQrcode: '二维码',
  colActivityInfo: '活动信息',
  colWinStatus: '中奖状态',
  colPrize: '奖项',
  colDrawTime: '开奖时间',
  colDrawRegion: '开奖地区',
  colAction: '操作',
  // 操作
  detail: '详情',
  // 详情弹窗
  detailTitle: '开奖详情',
  sectionMemberInfo: '开奖人信息',
  sectionActivityInfo: '开奖活动信息',
  sectionScanInfo: '扫码信息',
  detailMemberId: '用户ID',
  detailMemberName: '用户名称',
  detailPhone: '手机号',
  detailActivityId: '活动ID',
  detailActivityName: '活动名称',
  detailWinPrize: '中奖奖项',
  detailWinStrategy: '中奖策略',
  detailAwardStatus: '兑奖状态',
  detailCode: '二维码',
  detailCodeBatch: '二维码批次',
  detailProduct: '关联产品',
  detailScanTime: '扫码时间',
  detailScanRegion: '扫码国家/地区',
  // 占位
  dash: '——',
  // 空状态
  emptyText: '暂无开奖记录',
};
